/** @jsx jsx */
import React, { useMemo } from 'react';
import { jsx } from '@emotion/core';
import p from 'pluralize';
import { curry, __ } from 'ramda';

import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';
import { Tenant } from 'state/tenant';
import { InstantCredit } from 'state/instantCredit';

import styles from '../styles';

const pluralize = curry(p)(__, __, true);

interface PropTypes {
  tenant: Tenant;
  instantCredit: InstantCredit;
}
const Expiration: React.FC<PropTypes> = ({ tenant, instantCredit }) => {
  const tMd = useMarkdownTranslate();
  const { useInstantCreditTspTimeout } = tenant.session;
  const { expirationType, expirationValue } = instantCredit;
  const unit = expirationType === 'H' ? 'hour' : 'day';

  const expirationTime = useMemo(() => {
    if (useInstantCreditTspTimeout && expirationValue) {
      return pluralize(unit, expirationValue);
    }

    if (expirationType === 'H' && expirationValue === 1) {
      return '30 minutes';
    }

    return '60 minutes';
  }, [expirationType, expirationValue, unit, useInstantCreditTspTimeout]);

  const maxTime = useMemo(() => {
    if (useInstantCreditTspTimeout && expirationValue) {
      return pluralize(unit, expirationValue);
    }

    if (
      expirationType === 'H' &&
      (expirationValue === 1 || expirationValue === 2)
    ) {
      return '60 minutes';
    }

    if (expirationType != null && expirationValue != null) {
      return '3 hours';
    }

    return '4 hours';
  }, [expirationType, expirationValue, unit, useInstantCreditTspTimeout]);

  return (
    <p css={styles.normalText}>
      {tMd('dsp.dspContent.expirationMessage', {
        expiration: expirationTime,
        maxTime: maxTime,
      })}
    </p>
  );
};

export default Expiration;
